export default __webpack_public_path__ + "img/search.b8994d72.svg";